import {removeApiToken} from "../../api/request";

export const user = {
    namespaced: true,
    state: {
        userData: {
            loggedIn: false,
            prename: null,
            surname: null,
            email: null,
            role: 1,
            id: null,
            holidays_per_year: null,
            holidays_previous_year: null,
            additional_holidays: null,
            holidays_left_current_year: null,
            holidays_left_next_year: null,
            requested_holidays: null,
            workdays: null
        }
    },
    getters: {
        isLoggedIn: state => state.userData.loggedIn,
        user: state => {
            return {
                id:                         state.userData.id,
                email:                      state.userData.email,
                role:                       state.userData.role,
                prename:                    state.userData.prename,
                surname:                    state.userData.surname,
                holidays_per_year:          state.userData.holidays_per_year,
                holidays_previous_year:     state.userData.holidays_previous_year,
                additional_holidays:        state.userData.additional_holidays,
                holidays_left_current_year: state.userData.holidays_left_current_year,
                holidays_left_next_year:    state.userData.holidays_left_next_year,
                requested_holidays:         state.userData.requested_holidays,
                workdays:                   state.userData.workdays
            }
        }
    },
    actions: {
        login({commit})
        {
            commit('setLogin', true);
        },
        logout({commit})
        {
            commit('setLogin', false);
            commit('resetUserData');
        },
        setUser({commit}, userData)
        {
            commit('setUser', userData);
        }
    },
    mutations: {
        setLogin: (state, loginState) => (state.userData.loggedIn = loginState),
        setUser: function(state, userData)
        {
            state.userData.id = userData.id;
            state.userData.prename = userData.prename;
            state.userData.surname = userData.surname;
            state.userData.email = userData.email;
            state.userData.role = userData.role;
            state.userData.holidays_per_year = userData.holidays_per_year;
            state.userData.holidays_previous_year = userData.holidays_previous_year;
            state.userData.additional_holidays = userData.additional_holidays;
            state.userData.holidays_left_current_year = userData.holidays_left_current_year;
            state.userData.holidays_left_next_year = userData.holidays_left_next_year;
            state.userData.requested_holidays = userData.requested_holidays;
            state.userData.workdays = userData.workdays;
        },
        resetUserData: function(state)
        {
            state.userData.id =     null;
            state.userData.email =  null;
            state.userData.akten =  null;
            state.userData.prename = null;
            state.userData.surname = null;
            state.userData.role = null;
            state.userData.holidays_per_year = null;
            state.userData.holidays_previous_year = null;
            state.userData.additional_holidays = null;
            state.userData.holidays_left_current_year = null;
            state.userData.holidays_left_next_year = null;
            state.userData.requested_holidays = null;
            state.userData.workdays = null;
            removeApiToken();
        }
    }
};